import { useEffect, useRef, useState } from "react";
import { Pause, Square } from "lucide-react";
import { KarenOrb } from "./KarenOrb";
import { createKarenReader } from "../utils/karenReader";

// Existing lesson/help entry point, now exclusively the configured Karen voice.
export default function BrowserNarration({ text, title }) {
  const [state, setState] = useState("idle");
  const reader = useRef(null);
  useEffect(() => {
    setState("idle");
    reader.current = createKarenReader(text, { onState: setState });
    return () => reader.current?.dispose();
  }, [text]);
  const playing = state === "playing" || state === "pausing";
  return <div data-testid="browser-narration">
    <div className="flex items-center gap-4 mb-4">
      <KarenOrb active={playing} />
      <div><h3 className="font-bold text-slate-900">{title}</h3>
        <p className="text-sm text-slate-500">Read by Karen · internet connection required</p></div>
    </div>
    {!text?.trim() ? <p role="status">Karen needs the written lesson or transcript before she can read this recording.</p> : <>
      <div className="flex items-center gap-2">
        {playing ? <button data-testid="narration-pause" disabled={state === "pausing"}
          onClick={() => reader.current?.pause()}
          className="flex-1 min-h-11 rounded-xl bg-blue-600 px-4 text-white inline-flex items-center justify-center gap-2">
          <Pause className="w-4 h-4" />{state === "pausing" ? "Finishing this passage…" : "Pause after this passage"}
        </button> : <button data-testid="narration-play" onClick={() => reader.current?.play()}
          className="flex-1 min-h-11 rounded-xl bg-blue-600 px-4 text-white inline-flex items-center justify-center gap-2">
          <KarenOrb />{state === "paused" ? "Resume" : state === "error" ? "Retry Karen" : "Listen with Karen"}
        </button>}
        <button data-testid="narration-stop" onClick={() => reader.current?.stop()}
          className="min-h-11 px-4 rounded-xl border border-slate-200 inline-flex items-center gap-1">
          <Square className="w-3.5 h-3.5" />Stop
        </button>
      </div>
      {state === "error" && <p role="alert" className="text-sm text-amber-700 mt-2">Karen could not finish this passage. Retry to continue from here, or use the written content.</p>}
    </>}
  </div>;
}
